// @ts-nocheck
import { SVGProps } from "react";
import Exchange from "../../App/Assets/Icons/exchange.svg?react";
import Filter from "../../App/Assets/Icons/filter.svg?react";
import Table from "../../App/Assets/Icons/table.svg?react";
import Trendyol from "../../App/Assets/Icons/trendyol.svg?react";
import HeartPlus from "../../App/Assets/Icons/heartPlus.svg?react";
import UserCircle from "../../App/Assets/Icons/UserCircle.svg?react";
import Arrow from "../../App/Assets/Icons/arrow.svg?react";
import ArrowLeft from "../../App/Assets/Icons/arrowLeft.svg?react";
import Bars from "../../App/Assets/Icons/bars.svg?react";
import Boxes from "../../App/Assets/Icons/boxes.svg?react";
import Bracket from "../../App/Assets/Icons/bracket.svg?react";
import Chart from "../../App/Assets/Icons/chart.svg?react";
import ClipboardCheck from "../../App/Assets/Icons/clipboardcheck.svg?react";
import Copy from "../../App/Assets/Icons/copy.svg?react";
import DeleteLeft from "../../App/Assets/Icons/deleteLeft.svg?react";
import Ellipsis from "../../App/Assets/Icons/ellipsis.svg?react";
import Envelope from "../../App/Assets/Icons/envelope.svg?react";
import ListCheck from "../../App/Assets/Icons/listCheck.svg?react";
import Qr from "../../App/Assets/Icons/qr.svg?react";
import Question from "../../App/Assets/Icons/question.svg?react";
import Signin from "../../App/Assets/Icons/signin.svg?react";
import Spinner from "../../App/Assets/Icons/spinner.svg?react";
import Tachometer from "../../App/Assets/Icons/tachometer.svg?react";
import Th from "../../App/Assets/Icons/th.svg?react";
import Truck from "../../App/Assets/Icons/truck.svg?react";
import User from "../../App/Assets/Icons/user.svg?react";
import Users from "../../App/Assets/Icons/users.svg?react";
import Whatsapp from "../../App/Assets/Icons/whatsapp.svg?react";

import AiGenerate from "../../App/Assets/Icons/aiGenerate.svg?react";
import Android from "../../App/Assets/Icons/android.svg?react";
import Apple from "../../App/Assets/Icons/apple.svg?react";
import Appsmen from "../../App/Assets/Icons/appsmen.svg?react";
import ArrowRight from "../../App/Assets/Icons/arrowRight.svg?react";
import ArrowUpRight from "../../App/Assets/Icons/arrowUpRight.svg?react";
import BanContant from "../../App/Assets/Icons/bancontant.svg?react";
import Bank from "../../App/Assets/Icons/bank.svg?react";
import Barcode from "../../App/Assets/Icons/barcode.svg?react";
import Basket from "../../App/Assets/Icons/basket.svg?react";
import Belgium from "../../App/Assets/Icons/belgium.svg?react";
import BelgiumDutch from "../../App/Assets/Icons/belgiumDutch.svg?react";
import BelgiumFrench from "../../App/Assets/Icons/belgiumFrench.svg?react";
import Bell from "../../App/Assets/Icons/bell.svg?react";
import Biking from "../../App/Assets/Icons/biking.svg?react";
import CarrotDown from "../../App/Assets/Icons/carrotDown.svg?react";
import CashDrawer from "../../App/Assets/Icons/cashDrawer.svg?react";
import CashRegister from "../../App/Assets/Icons/cashRegister.svg?react";
import Check from "../../App/Assets/Icons/check.svg?react";
import CheckDouble from "../../App/Assets/Icons/checkDouble.svg?react";
import Chevron from "../../App/Assets/Icons/chevron.svg?react";
import CNY from "../../App/Assets/Icons/china.svg?react";
import Clone from "../../App/Assets/Icons/clone.svg?react";
import Cog from "../../App/Assets/Icons/cog.svg?react";
import Comment from "../../App/Assets/Icons/comment.svg?react";
import Credit from "../../App/Assets/Icons/credit.svg?react";
import Creditcard from "../../App/Assets/Icons/creditcard.svg?react";
import CrossHairs from "../../App/Assets/Icons/crosshairs.svg?react";
import Crown from "../../App/Assets/Icons/crown.svg?react";
import Deliveroo from "../../App/Assets/Icons/deliveroo.svg?react";
import Desktop from "../../App/Assets/Icons/desktop.svg?react";
import Download from "../../App/Assets/Icons/download.svg?react";
import Edit from "../../App/Assets/Icons/edit.svg?react";
import Exclamation from "../../App/Assets/Icons/exclamation.svg?react";
import Eye from "../../App/Assets/Icons/eye.svg?react";
import EyeSlash from "../../App/Assets/Icons/eyeslash.svg?react";
import Forward from "../../App/Assets/Icons/forward.svg?react";
import French from "../../App/Assets/Icons/french.svg?react";
import Fullscreen from "../../App/Assets/Icons/fullscreen.svg?react";
import Gear from "../../App/Assets/Icons/gear.svg?react";
import German from "../../App/Assets/Icons/german.svg?react";
import GreatBritain from "../../App/Assets/Icons/greatbritain.svg?react";
import Grip from "../../App/Assets/Icons/grip.svg?react";
import HalfStar from "../../App/Assets/Icons/halfstar.svg?react";
import Hashtag from "../../App/Assets/Icons/hashtag.svg?react";
import Headset from "../../App/Assets/Icons/headset.svg?react";
import Highlighter from "../../App/Assets/Icons/highlighter.svg?react";
import Home from "../../App/Assets/Icons/home.svg?react";
import Homie from "../../App/Assets/Icons/homie.svg?react";
import Ideal from "../../App/Assets/Icons/ideal.svg?react";
import Info from "../../App/Assets/Icons/info.svg?react";
import Keyboard from "../../App/Assets/Icons/keyboard.svg?react";
import Link from "../../App/Assets/Icons/link.svg?react";
import Map from "../../App/Assets/Icons/map.svg?react";
import Menu from "../../App/Assets/Icons/menu.svg?react";
import Minus from "../../App/Assets/Icons/minus.svg?react";
import Money from "../../App/Assets/Icons/money.svg?react";
import Motorcycle from "../../App/Assets/Icons/motorcycle.svg?react";
import Netherlands from "../../App/Assets/Icons/netherlands.svg?react";
import ObjectGroup from "../../App/Assets/Icons/objectGroup.svg?react";
import Package from "../../App/Assets/Icons/package.svg?react";
import PayLater from "../../App/Assets/Icons/payLater.svg?react";
import PayConiq from "../../App/Assets/Icons/payconiq.svg?react";
import Paypal from "../../App/Assets/Icons/paypal.svg?react";
import Pdf from "../../App/Assets/Icons/pdf.svg?react";
import Pencil from "../../App/Assets/Icons/pencil.svg?react";
import Percent from "../../App/Assets/Icons/percent.svg?react";
import Phone from "../../App/Assets/Icons/phone.svg?react";
import PhoneSlash from "../../App/Assets/Icons/phoneSlash.svg?react";
import Plus from "../../App/Assets/Icons/plus.svg?react";
import Polish from "../../App/Assets/Icons/polish.svg?react";
import Printer from "../../App/Assets/Icons/printer.svg?react";
import Receipt from "../../App/Assets/Icons/receipt.svg?react";
import Tag from "../../App/Assets/Icons/tag.svg?react";
import Reply from "../../App/Assets/Icons/reply.svg?react";
import RoadReady from "../../App/Assets/Icons/roadReady.svg?react";
import RotateLeft from "../../App/Assets/Icons/rotateLeft.svg?react";
import SackDollar from "../../App/Assets/Icons/sackDollar.svg?react";
import Scooter from "../../App/Assets/Icons/scooter.svg?react";

import Calender from "../../App/Assets/Icons/calender.svg?react";
import CodeCommit from "../../App/Assets/Icons/codeCommit.svg?react";
import Search from "../../App/Assets/Icons/search.svg?react";
import SearchPlus from "../../App/Assets/Icons/search_plus.svg?react";
import Seedling from "../../App/Assets/Icons/seedling.svg?react";
import SoundMute from "../../App/Assets/Icons/soundmute.svg?react";
import SoundUp from "../../App/Assets/Icons/soundup.svg?react";
import SplitPayment from "../../App/Assets/Icons/splitPayment.svg?react";
import StarRegular from "../../App/Assets/Icons/starregular.svg?react";
import StarSolid from "../../App/Assets/Icons/starsolid.svg?react";
import Sync from "../../App/Assets/Icons/sync.svg?react";
import Thuisbezorgd from "../../App/Assets/Icons/thuisbezorgd.svg?react";
import Times from "../../App/Assets/Icons/times.svg?react";
import Trash from "../../App/Assets/Icons/trash.svg?react";
import Turkiye from "../../App/Assets/Icons/turkiye.svg?react";
import UberEats from "../../App/Assets/Icons/uberEats.svg?react";
import UserPlus from "../../App/Assets/Icons/userPlus.svg?react";
import UserTie from "../../App/Assets/Icons/userTie.svg?react";
import Utensils from "../../App/Assets/Icons/utensils.svg?react";
import Windows from "../../App/Assets/Icons/windows.svg?react";
import StartPin from "../../App/Assets/Icons/startPin.svg?react";
import BrokenPin from "../../App/Assets/Icons/brokenPin.svg?react";
import Kiosk from "../../App/Assets/Icons/kiosk.svg?react";
import Location from "../../App/Assets/Icons/location.svg?react";
import CashDro from "../../App/Assets/Icons/cashDro.svg?react";
import Heart from "../../App/Assets/Icons/heart.svg?react";
import Spain from "../../App/Assets/Icons/spainflag.svg?react";
import Serbia from "../../App/Assets/Icons/serbiaFlag.svg?react";
import SaudiArabia from "../../App/Assets/Icons/arflag.svg?react";

export type IconsVariant =
  | "heart"
  | "heartPlus"
  | "trendyol"
  | "bracket"
  | "link"
  | "user_plus"
  | "deleteLeft"
  | "roadReady"
  | "arrowRight"
  | "biking"
  | "crown"
  | "user_circle"
  | "user"
  | "users"
  | "boxes"
  | "headset"
  | "bars"
  | "table"
  | "motorcycle"
  | "home"
  | "qr"
  | "pencil"
  | "carrotDown"
  | "highlighter"
  | "ellipsis"
  | "tachometer"
  | "map"
  | "apple"
  | "android"
  | "fullscreen"
  | "search"
  | "minus"
  | "spinner"
  | "times"
  | "plus"
  | "creditcard"
  | "trash"
  | "info"
  | "search_plus"
  | "nl"
  | "netherlands"
  | "thuisbezorgd"
  | "edit"
  | "objectgroup"
  | "bell"
  | "listCheck"
  | "arrowLeft"
  | "chart"
  | "calender"
  | "clipboardcheck"
  | "exclamation"
  | "exchange"
  | "menu"
  | "filter"
  | "th"
  | "sync"
  | "grip"
  | "signin"
  | "tr"
  | "turkiye"
  | "check"
  | "soundup"
  | "soundmute"
  | "copy"
  | "money"
  | "ideal"
  | "truck"
  | "question"
  | "utensils"
  | "seedling"
  | "printer"
  | "receipt"
  | "tag"
  | "envelope"
  | "desktop"
  | "chevron"
  | "cog"
  | "gb"
  | "greatebritain"
  | "arrow"
  | "cny"
  | "halfstar"
  | "starsolid"
  | "starregular"
  | "eye"
  | "eyeslash"
  | "rotate_left"
  | "clone"
  | "percent"
  | "basket"
  | "cashRegister"
  | "windows"
  | "download"
  | "belgium"
  | "deliveroo"
  | "uberEats"
  | "paypal"
  | "bank"
  | "scooter"
  | "package"
  | "forward"
  | "crosshairs"
  | "checkDouble"
  | "belgiumDutch"
  | "belgiumFrench"
  | "french"
  | "german"
  | "whatsapp"
  | "reply"
  | "keyboard"
  | "gear"
  | "sackDollar"
  | "comment"
  | "hashtag"
  | "appsmen"
  | "homie"
  | "polish"
  | "credit"
  | "phone"
  | "phoneSlash"
  | "aiGenerate"
  | "banContant"
  | "payConiq"
  | "payLater"
  | "cashDrawer"
  | "barcode"
  | "arrowUpRight"
  | "pdf"
  | "splitPayment"
  | "codeCommit"
  | "userTie"
  | "startPin"
  | "brokenPin"
  | "kiosk"
  | "location"
  | "cashDro"
  | "spain"
  | "serbia"
  | "saudiArabia";

export interface IconProps extends SVGProps<SVGSVGElement> {
  variants?: IconsVariant;
}

type Types = {
  [key in IconsVariant]: any;
};

const types: Types = {
  heart: Heart,
  heartPlus: HeartPlus,
  trendyol: Trendyol,
  bracket: Bracket,
  deleteLeft: DeleteLeft,
  printer: Printer,
  receipt: Receipt,
  tag: Tag,
  table: Table,
  roadReady: RoadReady,
  qr: Qr,
  crown: Crown,
  calender: Calender,
  exchange: Exchange,
  download: Download,
  link: Link,
  headset: Headset,
  highlighter: Highlighter,
  pencil: Pencil,
  info: Info,
  user_plus: UserPlus,
  user_circle: UserCircle,
  search_plus: SearchPlus,
  android: Android,
  arrowLeft: ArrowLeft,
  spinner: Spinner,
  carrotDown: CarrotDown,
  nl: Netherlands,
  netherlands: Netherlands,
  map: Map,
  apple: Apple,
  motorcycle: Motorcycle,
  minus: Minus,
  clipboardcheck: ClipboardCheck,
  cny: CNY,
  filter: Filter,
  user: User,
  whatsapp: Whatsapp,
  fullscreen: Fullscreen,
  exclamation: Exclamation,
  utensils: Utensils,
  creditcard: Creditcard,
  users: Users,
  gb: GreatBritain,
  greatebritain: GreatBritain,
  edit: Edit,
  arrowRight: ArrowRight,
  objectgroup: ObjectGroup,
  grip: Grip,
  tr: Turkiye,
  copy: Copy,
  turkiye: Turkiye,
  bell: Bell,
  home: Home,
  desktop: Desktop,
  soundmute: SoundMute,
  soundup: SoundUp,
  money: Money,
  ideal: Ideal,
  sync: Sync,
  search: Search,
  thuisbezorgd: Thuisbezorgd,
  bars: Bars,
  boxes: Boxes,
  biking: Biking,
  ellipsis: Ellipsis,
  tachometer: Tachometer,
  th: Th,
  listCheck: ListCheck,
  eye: Eye,
  eyeslash: EyeSlash,
  cog: Cog,
  plus: Plus,
  chart: Chart,
  menu: Menu,
  envelope: Envelope,
  truck: Truck,
  times: Times,
  seedling: Seedling,
  signin: Signin,
  question: Question,
  arrow: Arrow,
  check: Check,
  chevron: Chevron,
  trash: Trash,
  halfstar: HalfStar,
  starregular: StarRegular,
  starsolid: StarSolid,
  rotate_left: RotateLeft,
  clone: Clone,
  percent: Percent,
  basket: Basket,
  cashRegister: CashRegister,
  windows: Windows,
  belgium: Belgium,
  deliveroo: Deliveroo,
  uberEats: UberEats,
  paypal: Paypal,
  bank: Bank,
  scooter: Scooter,
  package: Package,
  forward: Forward,
  crosshairs: CrossHairs,
  checkDouble: CheckDouble,
  belgiumDutch: BelgiumDutch,
  belgiumFrench: BelgiumFrench,
  french: French,
  german: German,
  reply: Reply,
  keyboard: Keyboard,
  gear: Gear,
  sackDollar: SackDollar,
  comment: Comment,
  hashtag: Hashtag,
  appsmen: Appsmen,
  homie: Homie,
  polish: Polish,
  spain: Spain,
  serbia: Serbia,
  saudiArabia: SaudiArabia,
  credit: Credit,
  phone: Phone,
  phoneSlash: PhoneSlash,
  aiGenerate: AiGenerate,
  banContant: BanContant,
  payConiq: PayConiq,
  payLater: PayLater,
  cashDrawer: CashDrawer,
  barcode: Barcode,
  arrowUpRight: ArrowUpRight,
  pdf: Pdf,
  splitPayment: SplitPayment,
  codeCommit: CodeCommit,
  userTie: UserTie,
  startPin: StartPin,
  brokenPin: BrokenPin,
  kiosk: Kiosk,
  location: Location,
  cashDro: CashDro,
};

const Component = ({ variants = "check", ...props }: IconProps) => {
  const Type = types[variants];

  return <Type {...props} />;
};
export default Component;
